<template>
  <div id="modal" class="modal" v-show="opened">
    <div class="modal-content">
      <div class="modal-header shadow-sm">
        <button class="btn text-primary" @click="$emit('close')">
          <i class="fa-solid fa-chevron-left"></i>
        </button>
      </div>
      <div class="modal-body" :class="{'pt-0': noPad}">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Modal",
    props: ['opened', 'noPad']
  }
</script>

<style scoped>
  .modal {
    display: block; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 1050; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100vh;
    height: 100dvh;
    overflow: hidden;
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
  }

  .modal-content {
    background-color: var(--bg-theme);
    border: 1px solid #888;
    border-radius: 12px;
    max-width: 450px;
    margin: 48px auto;
    max-height: calc(100vh - 96px);
    max-height: calc(100dvh - 96px);
    overflow: hidden;
  }

  .modal-header {
    border-color: var(--border-color);
    padding: 8px;
    flex: 0 0 auto;
  }

  .modal-body {
    padding-top: 16px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  @media (max-width: 600px) {
    .modal-content {
      max-width: none;
      border-radius: 0;
      border: none;
      margin: 0;
      height: 100vh;
      height: 100dvh;
      max-height: none;
    }

    .modal-header {
      position: sticky;
      top: 0;
      z-index: 1;
    }

    .modal-body {
      padding-top: 16px;
    }
  }
</style>
